module.exports = __webpack_public_path__ + "media/images/image_check-fc00bb56a89d8c835fca5120bffc4efa.png";